import { motion } from "framer-motion";
import { Phone, ShoppingBag } from "lucide-react";
import { RESTAURANT } from "../data/site";

const FloatingCTAs = () => (
  <motion.div
    data-testid="floating-ctas"
    initial={{ opacity: 0, y: 24 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay: 2.2, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
    className="fixed bottom-5 left-4 right-4 z-40 flex gap-3 md:left-auto md:right-6 md:w-auto"
  >
    <a
      href={RESTAURANT.phoneHref}
      data-testid="floating-call-button"
      className="glass flex flex-1 items-center justify-center gap-2 rounded-full py-3.5 text-[12px] font-medium uppercase tracking-[0.18em] text-white transition-colors duration-300 hover:text-gold md:flex-none md:px-6"
    >
      <Phone size={14} className="text-gold" /> Call
    </a>
    <a
      href="/order"
      data-testid="floating-order-button"
      className="btn-gold flex flex-1 items-center justify-center gap-2 rounded-full py-3.5 text-[12px] font-semibold uppercase tracking-[0.18em] md:flex-none md:px-6"
    >
      <ShoppingBag size={14} /> Order Now
    </a>
  </motion.div>
);

export default FloatingCTAs;
